// Module
var code = `<div class="date-drop-down">
    {{#!isOnlyDate}}
        <div class="selector-buttons-switches">
            <terceraButton name="dateIcon"
                        SVG="true"
                        text="{{.buttonDateText}}"
                        canCheck="true"
                        btnInGroup="true"
                        checked={{.ShowDate}}
                        terceraButtonStyle="js-button-date"
                        on-componentClick="dateBtnClick" />
                        
            <terceraButton name="timeClock"
                        SVG="true"
                        text="{{.buttonTimeText}}"
                        canCheck="true"
                        btnInGroup="true"
                        checked={{!.ShowDate}}
                        terceraButtonStyle="js-button-time"
                        on-componentClick="timeBtnClick" 
                        visibl="{{!isOnlyDate}}"/>
        </div>
    {{/}}

    <terceraDatePickerCalendarComponent name="dtPicker" visible="{{.ShowDate}}" />

    {{#!isOnlyDate}}
        <div class="selector_hours_and_minutes" style="{{#.ShowDate}}display:none;{{/}}">
            <div class="hours_and_minutes_numeric">
                <reactTimeNumeric 
                    value="{{.hours}}" 
                    type="{{TimeScale.Hours}}" 
                    on-onValueChange="@this.onHoursChangedReact(\$1)" />

                <div class="two-points">
                    <span>:</span>
                </div>

                <reactTimeNumeric 
                    value="{{.minutes}}" 
                    type="{{TimeScale.Minutes}}" 
                    on-onValueChange="@this.onMinutesChangedReact(\$1)" />
            </div>

            <div class="time-selectors-container">
                <div class="time-selector">
                    <terceraLabel text="{{hoursLabel}}" />
                    <rangeSelector labels="{{labelsForHourSlider}}" count="9" max="23" rangeValue="{{hours}}" on-changedValue="onHoursChanged"/>
                </div>
    
                <div class="time-selector">
                    <terceraLabel visible="{{visible}}" text="{{minutesLabel}}" />
                    <rangeSelector labels="{{labelsForMinutesSlider}}" count="5" max="59" rangeValue="{{minutes}}" on-changedValue="onMinutesChanged"/>
                </div>
            </div>
        </div>
    {{/}}
    
    <div class="dateSelector-buttons-bar">
        {{#each buttons}}
            <terceraButton text="{{text}}" on-componentClick="['buttonClick', callback]" terceraButtonStyle="{{style}}"/>
        {{/each}}
    </div>
</div>`;
// Exports
export default code;